import jQuery from "jquery";
jQuery.noConflict();
window.$ = jQuery;
window.jQuery = jQuery;
import "bootstrap/dist/js/bootstrap.bundle";
import "node_modules/mdbootstrap/js/popper.js";
import 'slick-carousel';
import "node_modules/@fortawesome/fontawesome-free/js/all";
import 'node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.js';